import React from "react";
import { Github } from "lucide-react";
import { useNavigate } from "react-router-dom";
import ConnectGitHubButton from "./ConnectGitHubButton";

/**
 * First-run call to action. Kept narrow and self-contained so it can sit
 * above the fold at 375px on /welcome and in the empty repositories list.
 */
const ConnectGitHubCard = ({ className = "" }) => {
  const navigate = useNavigate();

  return (
    <div
      className={`bg-white border border-gray-200 rounded-xl p-6 sm:p-8 shadow-sm text-center w-full max-w-md mx-auto ${className}`}
    >
      <div className="bg-gray-900 rounded-xl w-12 h-12 flex items-center justify-center mx-auto mb-4">
        <Github className="w-6 h-6 text-white" />
      </div>
      <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-2">
        Connect GitHub to get started
      </h2>
      <p className="text-gray-600 text-sm mb-6">
        Pick a repository from your GitHub account and Fenny runs its first
        security scan.
      </p>
      <ConnectGitHubButton variant="oauth" label="Connect GitHub" />
      {/* This card has no GitHub auth state (deliberately — it renders on
          /welcome and in the empty repo list, neither of which should pay for
          an extra request). So give an already-connected user a way past the
          OAuth round-trip, and a way to /scan that isn't pinned to the
          paste-a-URL tab. */}
      <button
        type="button"
        onClick={() => navigate("/scan")}
        className="block mx-auto mt-3 px-2 min-h-[44px] text-sm text-gray-500 hover:text-gray-700 underline"
      >
        Already connected? Choose a repository
      </button>
      <button
        type="button"
        onClick={() => navigate("/scan?method=direct")}
        className="block mx-auto px-2 min-h-[44px] text-sm text-gray-500 hover:text-gray-700 underline"
      >
        Or paste a public repo URL
      </button>
    </div>
  );
};

export default ConnectGitHubCard;
